import React, { FC } from 'react'
import { useFormContext } from 'react-hook-form'
import { Input } from '@wmgtech/legato'

interface EditableCellProps extends Omit<React.HTMLAttributes<HTMLElement>, 'title'> {
  editing?: boolean
  dataIndex: string
  placeholder?: string
  index: number
  children: React.ReactNode
  value: string
  defaultValueState: any
}

export const EditableCell: FC<EditableCellProps> = ({
  dataIndex,
  placeholder,
  children,
  editing,
  defaultValueState,
  ...props
}) => {
  const { register } = useFormContext()
  return (
    <td {...props}>
      {editing ? (
        <Input
          {...register(dataIndex, {
            value: defaultValueState?.[dataIndex],
            shouldUnregister: true
          })}
          crossOrigin
          placeholder={placeholder}
        />
      ) : (
        children
      )}
    </td>
  )
}
